@if(type === 'Default') {
  <ejs-tooltip [attr.target]="tooltipTarget" [content]='text' [width]="width" [height]="height" [isSticky]="opensOn === 'Click'" [class]="class" [opensOn]="opensOn" [animation]="dialogService.getTooltipAnimation()" [position]="position" [cssClass]="cssClass" [windowCollision]="windowCollision" [offsetY]="offsetY" [offsetX]="offsetX">
    @if(icon) {
      <span [class]="'mts-icon cursor-pointer ' + iconClass">{{ icon }}</span>
    }
    <ng-content></ng-content>
  </ejs-tooltip>
} @else if(type === 'File' && file){
  <ejs-tooltip target=".file-info-icon" [content]='text' [width]="width" [height]="height" [isSticky]="opensOn === 'Click'" [class]="class" [opensOn]="opensOn" [animation]="dialogService.getTooltipAnimation()" [position]="position" [cssClass]="cssClass" [windowCollision]="windowCollision" [offsetY]="offsetY" [offsetX]="offsetX">
    @if(icon) {
      <span [class]="'file-info-icon mts-icon text-white fs-5 position-absolute top-0 start-0 ms-2 ms-sm-1 mt-1 mt-sm-0 lh-base ' + iconClass">{{ icon }}</span>
    }
    <ng-template #content>
      <div class="text-default">
        <div class="fs-default">
          <span class="fw-bold">{{ ('DOCUMENTFILENAME' | translate) }}:</span>
        </div>
        <span>{{ file.filename }}</span>

        <div class="my-1">
          <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTSIZE' | translate) }}:</span>
          <span>{{ file.size! | fileSize }}</span>
        </div>
        <div>
          <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTTYPE' | translate) }}:</span>
          <span class="text-uppercase">{{ documentService.getDocumentExtension(file) }}</span>
        </div>
      </div>
    </ng-template>
  </ejs-tooltip>
} @else if(type === 'Feedback' && feedbackListItem){
  <ejs-tooltip target=".feedback-info-icon" [content]='text' [width]="width" [height]="height" [isSticky]="opensOn === 'Click'" [class]="class" [opensOn]="opensOn" [animation]="dialogService.getTooltipAnimation()" [position]="position" [cssClass]="cssClass" [windowCollision]="windowCollision" [offsetY]="offsetY" [offsetX]="offsetX">
    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'" [class]="'feedback-info-icon cursor-pointer'"></app-icon-badge>
    <ng-template #content>
      <div class="width-max-content">
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'FEEDBACKQUESTIONS' | translate }}:</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">{{ feedbackListItem.questions ? feedbackListItem.questions : 0 }}</app-content>
        </div>
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'FEEDBACKCOMPLETED' | translate }}:</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">{{ feedbackListItem.completed_at | date }}</app-content>
        </div>
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'FEEDBACKTYPE' | translate }}:</app-content>
          @if(feedbackListItem.is_anonymous){
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">{{ 'FEEDBACKANONYMOUS' | translate }}</app-content>
          } @else {
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">{{ 'FEEDBACKNORMAL' | translate }}</app-content>
          }
        </div>
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'FEEDBACKPRIORITY' | translate }}:</app-content>
          @if(feedbackListItem.is_mandatory){
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">{{ 'FEEDBACKMANDATORY' | translate }}</app-content>
          } @else {
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">{{ 'FEEDBACKOPTIONAL' | translate }}</app-content>
          }
        </div>
      </div>
    </ng-template>
  </ejs-tooltip>
} @else if(type === 'Workflow' && workflowListItem){
  <ejs-tooltip target=".workflow-info-icon" [content]='text' [width]="width" [height]="height" [isSticky]="opensOn === 'Click'" [class]="class" [opensOn]="opensOn" [animation]="dialogService.getTooltipAnimation()" [position]="position" [cssClass]="cssClass" [windowCollision]="windowCollision" [offsetY]="offsetY" [offsetX]="offsetX">
    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'" [class]="'workflow-info-icon cursor-pointer'"></app-icon-badge>
    <ng-template #content>
      <div class="d-flex flex-column gap-1 width-max-content lh-1">
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTCREATED' | translate) }}:</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">{{ workflowListItem.created_at | date : 'medium' }}</app-content>
        </div>
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTELAPSED' | translate) }}:</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">{{ workflowListItem.elapsedDays }}</app-content>
        </div>
        @if(workflowListItem.completed_at){
          <div class="my-1 d-flex gap-1">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTCOMPLETED' | translate) }}:</app-content>
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-success'">{{ workflowListItem.completed_at | date : 'medium' }}</app-content>
          </div>
        }
        @if(workflowListItem.canceled_at){
          <div class="my-1 d-flex gap-1">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTCANCELED' | translate) }}:</app-content>
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-danger'">{{ workflowListItem.canceled_at | date : 'medium' }}</app-content>
          </div>
        }
        @if(workflowListItem.expired_at){
          <div class="my-1 d-flex gap-1">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTEXPIRED' | translate) }}:</app-content>
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-danger'">{{ workflowListItem.expired_at | date : 'medium' }}</app-content>
          </div>
        }
        @if(!workflowListItem.completed_at && !workflowListItem.canceled_at && !workflowListItem.expired_at){
          <div class="my-1 d-flex gap-1">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTEXPIRES' | translate) }}:</app-content>
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-orange'">{{ workflowListItem.expires_at | date : 'medium' }}</app-content>
          </div>
        }
  
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTTYPE' | translate) }}:</app-content>
          @if(workflowListItem.is_anonymous) {
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTTYPECONFIDENTIAL' | translate) }}</app-content>
          } @else {
            <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTTYPESTANDARD' | translate) }}</app-content>
          }
        </div>
        <div class="my-1 d-flex gap-1">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ ('WORKFLOWLISTSTATUS' | translate) }}:</app-content>
          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'" [fontColor]="workflowListItem.completed_at ? 'text-success' : (workflowListItem.canceled_at || workflowListItem.expired_at ? 'text-danger' : 'text-orange')">{{ workflowListItem.status }}</app-content>
        </div>
      </div>
    </ng-template>
  </ejs-tooltip>
}